import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';

import './index.scss';

const STEPS = [
  'Escolha a variável e o mês na configuração.',
  'Filtre as fases dos índices climáticos (ex.: El Niño moderado + IOD positivo) até restarem os anos análogos ao cenário atual.',
  'Toque em "Gerar Mapas" para ver a anomalia de cada ano.',
  'Remova anos que pareçam outliers fechando o card (a lista é atualizada junto).',
  'Gere o "Ensemble" para combinar os anos num mapa médio e baixe o PNG.',
];

export default function InfoSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Como usar a Similaridade"
      className="agro-simil-info-sheet"
    >
      <div className="agro-simil-info-sheet-body">
        <p className="agro-simil-info-sheet-intro">
          A Similaridade busca anos históricos análogos ao cenário climático atual usando
          índices de teleconexão (NIÑO 3.4, IOD, TNA, TSA, AMO, PDO, AAO). Se o padrão de hoje
          já ocorreu no passado, espera-se comportamento de chuva/temperatura parecido — uma
          previsão estatística por analogia.
        </p>
        <span className="agro-simil-info-sheet-label">Passo a passo</span>
        <ol className="agro-simil-info-sheet-steps">
          {STEPS.map((step) => (
            <li key={step} className="agro-simil-info-sheet-step">{step}</li>
          ))}
        </ol>
      </div>
    </BottomSheet>
  );
}
